<template>
    <div
        class="t-posters"
        :style="componentStyles"
    >
        <div class="t-posters-header">
            <slot name="header">
                <OPHeader />
            </slot>
        </div>
        <div 
            class="t-posters-lists" 
            v-if="!isShowVideo" 
        >
            <slot name="lists">
                <component :is="listComponent"/>
            </slot>
            <slot name="bottom-list-component" v-if="isShowBottomListComponent">
                <component :is="bottomListComponent"/>
            </slot>
        </div>
        <div class="t-posters-map-wrapper" v-show="!isShowVideo && isShowMapWrapper">
            <div class="t-posters-map">
                <slot name="map">
                    <OPMAP />
                </slot>
            </div>
            <div class="t-posters-icons" v-if="componentParams.is_show_map_service">
                <slot name="icons">
                    <OPMapIcons />
                </slot>
            </div>
            <div class="t-posters-logo" v-if="componentParams.is_show_map_logo">
                <slot name="logo">
                    <APosterLogo />
                </slot>
            </div>
            <div class="t-posters-info" v-if="componentParams.is_show_map_info">
                <slot name="poster-info">
                    <OPInfo />
                </slot>
            </div>
        </div>
        <div class="t-posters-video-wrapper" v-if="isShowVideo">
            <slot name="video">
                <OPVideo />
            </slot>
        </div>
        <div class="t-posters-info">
            <div class="t-posters-player">
                <slot name="player">
                    <OPPlayer />
                </slot>
            </div>
            <div class="t-posters-widget">
                <slot name="widget">
                    <component :is="widgetComponent"/>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import OPInfo from '../../organisms/o-p-info';
import OPMAP from '../../organisms/o-p-map/o-p-map';
import APosterLogo from '../../atoms/a-poster-logo';
import OPList from '../../organisms/o-p-list/o-p-list';
import OPVideo from '../../organisms/o-p-video/o-p-video';
import OPPlayer from '../../organisms/o-p-player/o-p-player';
import OPHeader from '../../organisms/o-p-header/o-p-header';
import OPosterSchedule from '../../organisms/o-poster-schedule';
import OPMapIcons from '../../organisms/o-p-map-icons/o-p-map-icons';
import OPQrWidget from '../../organisms/o-p-qr-widget/o-p-qr-widget';
import OPFloorList from '../../organisms/o-p-floor-list/o-p-floor-list';
import OPosterMobileMapQR from '../../organisms/o-poster-mobile-map-qr';
import OPFloorListSmart from '../../organisms/o-p-floor-list-smart/o-p-floor-list-smart';

import {SET_ACTIVE_VIEW} from "@/shared/components/map-viewer/constants/map-commands";

import {reportWarning} from "@/utils/helpers/health-monitoring";

export default {
    name: 'TPosters',
    components: {
        OPMAP,
        OPList,
        OPInfo,
        OPVideo,
        OPHeader,
        OPPlayer,
        OPQrWidget,
        OPMapIcons,
        APosterLogo,
        OPFloorList,
        OPFloorList,
        OPosterSchedule,
        OPFloorListSmart,
        OPosterMobileMapQR,
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            checkSizeTimeout: null
        }
    },
    computed: {
        ...mapGetters([
            'getTerminalId',
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.TPosters.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.TPosters.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.TPosters.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.TPosters.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isShowVideo() {
            return this.componentParams.is_show_video_wrapper
        },
        isShowMapWrapper() {
            if(this.componentParams.hasOwnProperty('is_show_map_wrapper')) {
                return this.componentParams.is_show_map_wrapper
            }
            return true
        },
        activeView() {
            return this.componentParams.active_view || 'floorView'
        },
        listComponent() {
            return this.componentParams.list_component || 'OPList'
        },
        widgetComponent() {
            return this.componentParams.widget_component || 'OPQrWidget'
        },
        isShowBottomListComponent() {
            return this.componentParams.is_show_bottom_list_component;
        },
        bottomListComponent() {
            return this.componentParams.bottom_list_component || 'OPosterSchedule'
        }
    },
    methods: {
        checkListSize() {
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const items = Array.from(document.querySelectorAll('div'))
                .filter(el => el.getBoundingClientRect().x)

            const lastItem = items[items.length - 1]

            const lastItemRect = lastItem.getBoundingClientRect();

            if(lastItemRect.bottom > windowHeight || lastItemRect.right > windowWidth ) {
                const msg = `: poster are not palced, in poster with id: ${this.getTerminalId}`;
                reportWarning(msg);
            }

        }
    },
    mounted() {
        this.$bus.$emit(SET_ACTIVE_VIEW, this.activeView);
        this.checkSizeTimeout = setTimeout(this.checkListSize, 60000)
    },
    beforeDestroy() {
        if(this.checkSizeTimeout) clearTimeout(this.checkSizeTimeout)
    }
}
</script>

<style lang="scss" src="./theme.scss" />
